// extracted by mini-css-extract-plugin
module.exports = {"title":"ValidateEmailTitle_title__1J2Fe","subTitle":"ValidateEmailTitle_subTitle__13GFL"};